import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from '../adapter-registry';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { Model } from '../../backendmodel';
import { FabricWebLinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FabricWebLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {},
            parameters: '*'
        }
    }
})
export class FabricWebLinkedServiceAdapter extends LinkedServiceAdapter<FabricWebLinkedService> {

    protected modelConstructor(): new () => FabricWebLinkedService {
        return FabricWebLinkedService;
    }

    protected model(): IModel {
        return FabricWebLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(_linkedService: FabricWebLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        return linkedServiceResource;
    }
    
    protected async propertiesToModelAsync(_linkedServiceResource: Model.LinkedServiceResource, linkedService: FabricWebLinkedService): Promise<FabricWebLinkedService> {
        return linkedService;
    }
}
